const initialState = {
  license: null,
  planDefinitions: null,
  activePromotion: null,
  adminUids: [],
  loading: false,
  error: null
};

const licenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_LICENSE_START':
      return { ...state, loading: true, error: null };

    case 'FETCH_LICENSE_SUCCESS':
      return { ...state, loading: false, license: action.payload, error: null };

    case 'FETCH_LICENSE_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'FETCH_PLAN_DEFINITIONS_SUCCESS':
      return { ...state, planDefinitions: action.payload };

    case 'FETCH_PROMOTION_SUCCESS':
      return { ...state, activePromotion: action.payload };

    case 'FETCH_ADMIN_UIDS_SUCCESS':
      return { ...state, adminUids: action.payload };

    case 'CLEAR_LICENSE':
      return initialState;

    default:
      return state;
  }
};

export default licenseReducer;
